import { get_staff_summary, download_staff_pdf, getShiftTemplatesService } from "services/api-service";
import { REACT_APP_API_URL } from "../../config/api-config";
import React, { useState, useEffect, useMemo } from "react";

function AsyncImage({ src, alt, style, onClick }) {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div
      onClick={onClick}
      style={{
        position: "relative",
        width: style.width || "100%",
        maxWidth: style.maxWidth || "130px",
        height: style.height || "130px",
        display: "inline-block",
        cursor: onClick ? "pointer" : "default"
      }}
    >
      {!hasLoaded && !error && (
        <div
          style={{
            position: "absolute", top: 0, left: 0, width: "100%", height: "100%", borderRadius: style.borderRadius || "6px",
            backgroundColor: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center",
            color: "#94a3b8", fontSize: "11px", fontWeight: "500", border: "1px dashed #cbd5e1", zIndex: 1,
          }}
        >
          Loading...
        </div>
      )}
      {error && (
        <div
          style={{
            position: "absolute", top: 0, left: 0, width: "100%", height: "100%", borderRadius: style.borderRadius || "6px",
            backgroundColor: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center",
            color: "#ef4444", fontSize: "11px", fontWeight: "500", border: "1px solid #fca5a5", zIndex: 1,
          }}
        >
          No Image
        </div>
      )}
      <img src={src} alt={alt} loading="lazy" style={{ ...style, opacity: hasLoaded ? 1 : 0, transition: "opacity 0.2s ease-in-out" }} onLoad={() => setHasLoaded(true)} onError={() => setError(true)} />
    </div>
  );
}

function WorkingSessionsDisplay({ staff, onImageClick }) {
  const [expandedSessions, setExpandedSessions] = useState(false);
  const getWorkingSessions = () => (!staff || !staff.working_sessions) ? null : staff.working_sessions;
  const workingSessions = getWorkingSessions();

  if (!workingSessions || !workingSessions.sessions || workingSessions.sessions.length === 0) {
    return (
      <div style={{ marginTop: "15px", backgroundColor: "white", padding: "20px", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
        <p style={{ margin: "0 0 12px 0", fontWeight: "600", color: "#374151", fontSize: "14px" }}>⏱️ Working Sessions ({workingSessions?.total_sessions || 0})</p>
        <div style={{ padding: "30px", color: "#999", fontSize: "13px", textAlign: "center", backgroundColor: "#f9fafb", borderRadius: "6px", border: "1px dashed #e5e7eb" }}>
          ℹ️ No working session data available
        </div>
      </div>
    );
  }

  const sessions = workingSessions.sessions || [];

  return (
    <div style={{ marginTop: "15px", backgroundColor: "white", padding: "20px", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
        <h5 style={{ margin: "0", fontWeight: "600", color: "#374151", fontSize: "14px" }}>⏱️ Working Sessions ({sessions.length} sessions)</h5>
        <button onClick={() => setExpandedSessions(!expandedSessions)} style={{ padding: "6px 12px", backgroundColor: "#f1f5f9", color: "#1e40af", border: "1px solid #cbd5e1", borderRadius: "4px", cursor: "pointer", fontWeight: "600", fontSize: "12px", transition: "all 0.2s" }}>
          {expandedSessions ? "Collapse" : "Expand"}
        </button>
      </div>

      <div style={{ maxHeight: expandedSessions ? "600px" : "300px", overflowY: "auto", overflowX: "hidden" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {sessions.map((session, idx) => (
            <div key={idx} style={{ padding: "16px", backgroundColor: idx % 2 === 0 ? "#f8fafc" : "#ffffff", borderLeft: "4px solid #3b82f6", borderRadius: "8px", border: "1px solid #e2e8f0", display: "flex", gap: "16px", alignItems: "center" }}>
              
              <div style={{ flexShrink: 0, width: "50px", textAlign: "center" }}>
                <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "28px", height: "28px", borderRadius: "50%", backgroundColor: "#dbeafe", color: "#1e40af", fontSize: "12px", fontWeight: "800", marginBottom: "6px" }}>
                  {idx + 1}
                </div>
                <div style={{ fontSize: "11px", fontWeight: "800", color: "#1e40af" }}>{session.duration_hours}h</div>
              </div>

              <div style={{ flexGrow: 1, display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                
                {/* Entry Block with Photo */}
                <div style={{ padding: "12px", backgroundColor: "#ecfdf5", borderRadius: "8px", border: "1px solid #a7f3d0", display: "flex", alignItems: "center", gap: "12px" }}>
                  {session.entry_image ? (
                    <AsyncImage 
                      src={`${REACT_APP_API_URL}${session.entry_image}`} 
                      alt="Entry" 
                      style={{ width: "50px", height: "50px", borderRadius: "6px", objectFit: "cover", border: "2px solid #10b981", boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }} 
                      onClick={() => onImageClick(`${REACT_APP_API_URL}${session.entry_image}`)}
                    />
                  ) : (
                    <div style={{ width: "50px", height: "50px", borderRadius: "6px", backgroundColor: "#d1fae5", display: "flex", alignItems: "center", justifyContent: "center", color: "#059669", fontSize: "9px", border: "1px dashed #6ee7b7" }}>No IMG</div>
                  )}
                  <div>
                    <div style={{ fontSize: "11px", fontWeight: "800", color: "#059669", textTransform: "uppercase", marginBottom: "2px" }}>✅ Check-In</div>
                    <div style={{ fontSize: "15px", fontWeight: "800", color: "#0f172a" }}>{session.entry}</div>
                    <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px", fontWeight: "600" }}>Cam {session.entry_camera}</div>
                  </div>
                </div>

                {/* Exit Block with Photo */}
                <div style={{ padding: "12px", backgroundColor: "#fef2f2", borderRadius: "8px", border: "1px solid #fecaca", display: "flex", alignItems: "center", gap: "12px" }}>
                  {session.exit_image ? (
                    <AsyncImage 
                      src={`${REACT_APP_API_URL}${session.exit_image}`} 
                      alt="Exit" 
                      style={{ width: "50px", height: "50px", borderRadius: "6px", objectFit: "cover", border: "2px solid #ef4444", boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }} 
                      onClick={() => onImageClick(`${REACT_APP_API_URL}${session.exit_image}`)}
                    />
                  ) : session.exit === "Active" ? (
                    <div style={{ width: "50px", height: "50px", borderRadius: "6px", backgroundColor: "#fef3c7", display: "flex", alignItems: "center", justifyContent: "center", color: "#d97706", fontSize: "10px", border: "1px dashed #fcd34d", fontWeight: "700", textAlign: "center" }}>INSIDE</div>
                  ) : (
                    <div style={{ width: "50px", height: "50px", borderRadius: "6px", backgroundColor: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center", color: "#dc2626", fontSize: "9px", border: "1px dashed #fca5a5" }}>No IMG</div>
                  )}
                  <div>
                    <div style={{ fontSize: "11px", fontWeight: "800", color: "#dc2626", textTransform: "uppercase", marginBottom: "2px" }}>❌ Check-Out</div>
                    <div style={{ fontSize: "15px", fontWeight: "800", color: "#0f172a" }}>{session.exit}</div>
                    <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px", fontWeight: "600" }}>{session.exit === "Active" ? "—" : `Cam ${session.exit_camera}`}</div>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default function StaffAttendanceTable() {
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];

  const [activeView, setActiveView] = useState("daily");

  const [selectedDate, setSelectedDate] = useState(formattedToday);
  const [staffMembers, setStaffMembers] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [shiftTemplates, setShiftTemplates] = useState([]);
  
  // Filters
  const [selectedShift, setSelectedShift] = useState("all");
  const [selectedStaffName, setSelectedStaffName] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [expandedDetectionLog, setExpandedDetectionLog] = useState(null);
  const [enlargedImage, setEnlargedImage] = useState(null);

  const [rangeStartDate, setRangeStartDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date.toISOString().split("T")[0];
  });
  const [rangeEndDate, setRangeEndDate] = useState(formattedToday);
  const [rangeData, setRangeData] = useState([]);
  const [rangeLoading, setRangeLoading] = useState(false);

  const [rangeSelectedShift, setRangeSelectedShift] = useState("all");
  const [rangeSelectedDepartment, setRangeSelectedDepartment] = useState("");
  const [rangeSelectedLocation, setRangeSelectedLocation] = useState("");
  const [rangeSelectedStaffName, setRangeSelectedStaffName] = useState("");

  useEffect(() => {
    getShiftTemplatesService()
      .then(res => setShiftTemplates(res.data?.data || []))
      .catch(err => console.error("Error loading shift templates:", err));
  }, []);

  const fetchDataByDate = async () => {
    if (!selectedDate) return;
    try {
      setLoading(true);
      const payload = {
        date: selectedDate,
        shift_id: selectedShift !== "all" ? selectedShift : undefined,
        page_number: 1,
        page_size: 5000,
      };

      const response = await get_staff_summary(payload);
      setStaffMembers(response?.data?.data || []);
      setSummary(response?.data?.summary || null);
    } catch (error) {
      console.error("Error fetching data:", error);
      setStaffMembers([]);
      setSummary(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchDateRangeReport = async () => {
    if (!rangeStartDate || !rangeEndDate) return;
    try {
      setRangeLoading(true);
      const start = new Date(rangeStartDate);
      const end = new Date(rangeEndDate);
      const allDates = [];
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        allDates.push(d.toISOString().split("T")[0]);
      }

      const allData = [];
      for (const date of allDates) {
        try {
          const payload = { 
            date, 
            shift_id: rangeSelectedShift !== "all" ? rangeSelectedShift : undefined,
            page_number: 1, 
            page_size: 5000 
          };
          const response = await get_staff_summary(payload);
          allData.push(...(response?.data?.data || []));
        } catch (err) {}
      }
      setRangeData(allData);
    } catch (error) {
      console.error("Error fetching range data:", error);
      setRangeData([]);
    } finally {
      setRangeLoading(false);
    }
  };

  useEffect(() => {
    if (activeView === "daily") fetchDataByDate();
  }, [selectedDate, selectedShift, activeView]);

  const filteredStaff = useMemo(() => {
    return staffMembers.filter((staff) => {
      const matchesStaffName = !selectedStaffName || staff.staff_name === selectedStaffName;
      const matchesDepartment = !selectedDepartment || staff.department === selectedDepartment;
      const matchesStatus = selectedStatus === "all" || staff.status === selectedStatus;
      const matchesLocation = !selectedLocation || staff.location === selectedLocation;
      return matchesStaffName && matchesDepartment && matchesStatus && matchesLocation;
    });
  }, [staffMembers, selectedStaffName, selectedDepartment, selectedStatus, selectedLocation]);

  const uniqueStaffNames = [...new Set(staffMembers.map((s) => s.staff_name).filter(Boolean))].sort();
  const uniqueDepartments = [...new Set(staffMembers.map((s) => s.department).filter(Boolean))].sort();
  const uniqueLocations = [...new Set(staffMembers.map((s) => s.location).filter(Boolean))].sort();

  const correctedSummary = useMemo(() => {
    if (!summary) return null;
    const totalStaff = summary.total_staff || 0;
    const presentCount = summary.present || 0;
    const absentCount = Math.max(totalStaff - presentCount, 0);
    const attendancePercentage = totalStaff > 0 ? ((presentCount / totalStaff) * 100).toFixed(1) : 0;
    return { ...summary, present: presentCount, absent: absentCount, attendance_percentage: attendancePercentage, total_staff: totalStaff };
  }, [summary]);

  const processRangeData = () => {
    const reportMap = {};
    rangeData.forEach((record) => {
      const staffId = record.staff_id;
      if (!reportMap[staffId]) {
        reportMap[staffId] = {
          staff_id: staffId,
          staff_name: record.staff_name,
          department: record.department,
          location: record.location,
          shift_id: record.shift_id,
          total_days: 0,
          present_days: 0,
          absent_days: 0,
          attendance_percentage: 0,
          total_working_hours: 0,
          avg_working_hours: 0,
        };
      }
      reportMap[staffId].total_days += 1;
      if (record.status === "Present") {
        reportMap[staffId].present_days += 1;
        reportMap[staffId].total_working_hours += record.total_working_hours || 0;
      } else {
        reportMap[staffId].absent_days += 1;
      }
    });

    Object.values(reportMap).forEach((record) => {
      record.attendance_percentage = record.total_days > 0 ? Math.round((record.present_days / record.total_days) * 100) : 0;
      record.avg_working_hours = record.present_days > 0 ? (record.total_working_hours / record.present_days).toFixed(2) : 0;
    });

    let filtered = Object.values(reportMap);
    if (rangeSelectedDepartment) filtered = filtered.filter(r => r.department === rangeSelectedDepartment);
    if (rangeSelectedLocation) filtered = filtered.filter(r => r.location === rangeSelectedLocation);
    if (rangeSelectedStaffName) filtered = filtered.filter(r => r.staff_name.toLowerCase().includes(rangeSelectedStaffName.toLowerCase()));

    return filtered.sort((a, b) => a.staff_name.localeCompare(b.staff_name));
  };

  const rangeReport = processRangeData();
  const rangeUniqueDepartments = [...new Set(rangeData.map((s) => s.department).filter(Boolean))].sort();
  const rangeUniqueLocations = [...new Set(rangeData.map((s) => s.location).filter(Boolean))].sort();
  const rangeUniqueStaffNames = [...new Set(rangeData.map((s) => s.staff_name).filter(Boolean))].sort();

  const handleDownloadPDF = async () => {
    try {
      const payload = {
        date: selectedDate,
        staff_name: selectedStaffName || undefined,
        status: selectedStatus !== "all" ? selectedStatus : undefined,
        department: selectedDepartment || undefined,
        location: selectedLocation || undefined,
        shift_id: selectedShift !== "all" ? selectedShift : undefined,
      };
      
      const response = await download_staff_pdf(payload);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `corporate_attendance_${selectedDate}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading PDF:", error);
      alert("Failed to download PDF. No records matched your current filters.");
    }
  };

  return (
    <div style={{ padding: "24px", backgroundColor: "#f8fafc", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>
      <div style={{ marginBottom: "24px" }}>
        <h1 style={{ margin: "0 0 16px 0", fontSize: "28px", fontWeight: "700", color: "#0f172a" }}>👥 Staff Attendance Tracking</h1>
      </div>

      <div style={{ display: "flex", gap: "16px", marginBottom: "24px", borderBottom: "2px solid #e2e8f0" }}>
        <button onClick={() => setActiveView("daily")} style={{ padding: "12px 24px", backgroundColor: "transparent", color: activeView === "daily" ? "#1e40af" : "#64748b", border: "none", borderBottom: activeView === "daily" ? "3px solid #1e40af" : "none", cursor: "pointer", fontWeight: activeView === "daily" ? "700" : "500", fontSize: "15px" }}>Daily Operations</button>
        <button onClick={() => setActiveView("range")} style={{ padding: "12px 24px", backgroundColor: "transparent", color: activeView === "range" ? "#1e40af" : "#64748b", border: "none", borderBottom: activeView === "range" ? "3px solid #1e40af" : "none", cursor: "pointer", fontWeight: activeView === "range" ? "700" : "500", fontSize: "15px" }}>Period Analytics</button>
      </div>

      {activeView === "daily" && (
        <div className="card border-0 shadow-sm rounded-4 mb-4 bg-white" style={{ border: "1px solid rgba(13, 110, 253, 0.1)" }}>
          <div className="card-body p-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-2 col-sm-6">
                <span className="d-block text-secondary small fw-bold mb-2 text-uppercase" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>Date</span>
                <input type="date" className="form-control rounded-3 border-0 shadow-sm text-secondary fw-semibold py-2" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} style={{ width: "100%", paddingRight: "10px" }} />
              </div>

              <div className="col-md-2 col-sm-6">
                <span className="d-block text-primary small fw-bold mb-2 text-uppercase" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>Filter by Shift</span>
                <select className="form-select rounded-3 border-0 shadow-sm fw-bold text-primary py-2" value={selectedShift} onChange={(e) => setSelectedShift(e.target.value)} style={{ width: "100%" }}>
                  <option value="all">All Shifts</option>
                  <option value="0">Default Shift</option>
                  {shiftTemplates.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-3 col-sm-6">
                <span className="d-block text-secondary small fw-bold mb-2 text-uppercase" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>Employee</span>
                <select className="form-select rounded-3 border-0 shadow-sm text-secondary fw-semibold py-2" value={selectedStaffName} onChange={(e) => setSelectedStaffName(e.target.value)} style={{ width: "100%" }}>
                  <option value="">All Employees</option>
                  {uniqueStaffNames.map((name) => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>

              <div className="col-md-2 col-sm-6">
                <span className="d-block text-secondary small fw-bold mb-2 text-uppercase" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>Status</span>
                <select className="form-select rounded-3 border-0 shadow-sm text-secondary fw-semibold py-2" value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)} style={{ width: "100%" }}>
                  <option value="all">All Status</option>
                  <option value="Present">Present</option>
                  <option value="Absent">Absent</option>
                </select>
              </div>

              <div className="col-md-2 col-sm-6">
                <span className="d-block text-secondary small fw-bold mb-2 text-uppercase" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>Department</span>
                <select className="form-select rounded-3 border-0 shadow-sm text-secondary fw-semibold py-2" value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value)} style={{ width: "100%" }}>
                  <option value="">All Depts</option>
                  {uniqueDepartments.map((dept) => <option key={dept} value={dept}>{dept}</option>)}
                </select>
              </div>
              
              <div className="col-md-1 col-sm-12">
                 <button onClick={() => { setSelectedShift("all"); setSelectedStaffName(""); setSelectedStatus("all"); setSelectedDepartment(""); setSelectedLocation(""); }} className="btn btn-light w-100 rounded-3 shadow-sm fw-bold py-2 text-secondary" style={{ border: "1px solid #e2e8f0" }}>Clear</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeView === "range" && (
        <>
          <div className="card border-0 shadow-sm rounded-4 mb-4 bg-white" style={{ border: "1px solid rgba(13, 110, 253, 0.1)" }}>
            <div className="card-body p-4">
              <div className="row g-3 align-items-end">
                <div className="col-md-2 col-sm-6">
                  <span className="d-block text-secondary small fw-bold mb-2 text-uppercase" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>Start Date</span>
                  <input type="date" className="form-control rounded-3 border-0 shadow-sm text-secondary fw-semibold py-2" value={rangeStartDate} onChange={(e) => setRangeStartDate(e.target.value)} style={{ width: "100%", paddingRight: "10px" }} />
                </div>

                <div className="col-md-2 col-sm-6">
                  <span className="d-block text-secondary small fw-bold mb-2 text-uppercase" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>End Date</span>
                  <input type="date" className="form-control rounded-3 border-0 shadow-sm text-secondary fw-semibold py-2" value={rangeEndDate} onChange={(e) => setRangeEndDate(e.target.value)} style={{ width: "100%", paddingRight: "10px" }} />
                </div>

                <div className="col-md-2 col-sm-6">
                  <span className="d-block text-primary small fw-bold mb-2 text-uppercase" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>Filter by Shift</span>
                  <select className="form-select rounded-3 border-0 shadow-sm fw-bold text-primary py-2" value={rangeSelectedShift} onChange={(e) => setRangeSelectedShift(e.target.value)} style={{ width: "100%" }}>
                    <option value="all">All Shifts</option>
                    <option value="0">Default Shift</option>
                    {shiftTemplates.map((t) => (
                      <option key={t.id} value={t.id}>{t.name}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <button onClick={fetchDateRangeReport} className="btn btn-primary w-100 rounded-3 shadow-sm fw-bold py-2">📊 Generate Report</button>
                </div>
              </div>
            </div>
          </div>

          {rangeData.length > 0 && (
            <div className="card border-0 shadow-sm rounded-4 mb-4 bg-white" style={{ border: "1px solid rgba(13, 110, 253, 0.1)" }}>
              <div className="card-body p-4">
                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <select className="form-select rounded-3 border-0 shadow-sm text-secondary fw-semibold py-2" value={rangeSelectedDepartment} onChange={(e) => setRangeSelectedDepartment(e.target.value)}>
                      <option value="">All Departments</option>
                      {rangeUniqueDepartments.map(dept => <option key={dept} value={dept}>{dept}</option>)}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <select className="form-select rounded-3 border-0 shadow-sm text-secondary fw-semibold py-2" value={rangeSelectedStaffName} onChange={(e) => setRangeSelectedStaffName(e.target.value)}>
                      <option value="">All Employees</option>
                      {rangeUniqueStaffNames.map(name => <option key={name} value={name}>{name}</option>)}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <button onClick={() => { setRangeSelectedDepartment(""); setRangeSelectedLocation(""); setRangeSelectedStaffName(""); }} className="btn btn-light w-100 rounded-3 shadow-sm fw-bold py-2 text-secondary" style={{ border: "1px solid #e2e8f0" }}>Clear Filters</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {activeView === "daily" && !loading && correctedSummary && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "20px", marginBottom: "24px" }}>
          <div style={{ backgroundColor: "white", padding: "24px", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", border: "1px solid #e2e8f0", borderTop: "4px solid #1e40af" }}>
            <div style={{ fontSize: "13px", color: "#64748b", fontWeight: "600", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Total Workforce</div>
            <div style={{ fontSize: "38px", fontWeight: "800", color: "#0f172a" }}>{correctedSummary.total_staff}</div>
          </div>
          <div style={{ backgroundColor: "white", padding: "24px", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", border: "1px solid #e2e8f0", borderTop: "4px solid #10b981" }}>
            <div style={{ fontSize: "13px", color: "#64748b", fontWeight: "600", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Active/Present</div>
            <div style={{ fontSize: "38px", fontWeight: "800", color: "#10b981" }}>{correctedSummary.present}</div>
          </div>
          <div style={{ backgroundColor: "white", padding: "24px", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", border: "1px solid #e2e8f0", borderTop: "4px solid #ef4444" }}>
            <div style={{ fontSize: "13px", color: "#64748b", fontWeight: "600", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Absent</div>
            <div style={{ fontSize: "38px", fontWeight: "800", color: "#ef4444" }}>{correctedSummary.absent}</div>
          </div>
        </div>
      )}

      {activeView === "daily" && !loading && staffMembers.length > 0 && (
        <div style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", overflow: "hidden", marginBottom: "20px", border: "1px solid #e2e8f0" }}>
          <div style={{ padding: "20px 24px", borderBottom: "1px solid #e2e8f0", backgroundColor: "#f8fafc", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h2 style={{ margin: "0", fontSize: "16px", fontWeight: "700", color: "#0f172a" }}>Attendance Roster ({filteredStaff.length})</h2>
            <button onClick={handleDownloadPDF} style={{ padding: "8px 16px", backgroundColor: "#1e40af", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "600", fontSize: "13px" }}>📄 Export PDF</button>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f1f5f9", borderBottom: "2px solid #e2e8f0" }}>
                  <th style={{ padding: "16px 24px", textAlign: "left", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px" }}>Employee</th>
                  <th style={{ padding: "16px 24px", textAlign: "left", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px" }}>Department</th>
                  <th style={{ padding: "16px 24px", textAlign: "left", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px" }}>First In</th>
                  <th style={{ padding: "16px 24px", textAlign: "left", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px" }}>Last Out</th>
                  <th style={{ padding: "16px 24px", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px" }}>Sessions</th>
                  <th style={{ padding: "16px 24px", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px" }}>Work Hrs</th>
                  <th style={{ padding: "16px 24px", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px" }}>Status</th>
                  <th style={{ padding: "16px 24px", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px" }}>Details</th>
                </tr>
              </thead>
              <tbody>
                {filteredStaff.map((staff, idx) => (
                  <React.Fragment key={staff.id || staff.staff_id}>
                    <tr style={{ borderBottom: "1px solid #e2e8f0", backgroundColor: "#ffffff", opacity: staff.status === "Absent" ? 0.7 : 1, transition: "background-color 0.2s" }} onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f8fafc"} onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#ffffff"}>
                      <td style={{ padding: "16px 24px" }}>
                        <div style={{ fontWeight: "700", color: "#0f172a" }}>{staff.staff_name}</div>
                        <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>ID: {staff.staff_id}</div>
                      </td>
                      <td style={{ padding: "16px 24px" }}>
                        <div style={{ color: "#475569", fontWeight: "600" }}>{staff.department || "—"}</div>
                        <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "2px", textTransform: "uppercase", letterSpacing: "0.5px" }}>{staff.shift_name}</div>
                      </td>
                      
                      <td style={{ padding: "16px 24px" }}>
                        <div style={{ color: staff.check_in_time ? "#0f172a" : "#94a3b8", fontWeight: "700", fontSize: "15px" }}>
                          {staff.check_in_time ? staff.check_in_time.substring(0, 5) : "—"}
                        </div>
                        {staff.arrival_status && staff.arrival_status !== "N/A" && (
                          <div style={{ 
                            marginTop: "4px", fontSize: "11px", fontWeight: "700", display: "inline-block", padding: "2px 6px", borderRadius: "4px",
                            backgroundColor: staff.arrival_status.includes("Late") ? "#fee2e2" : staff.arrival_status.includes("Early") ? "#e0e7ff" : "#d1fae5",
                            color: staff.arrival_status.includes("Late") ? "#dc2626" : staff.arrival_status.includes("Early") ? "#4f46e5" : "#059669"
                          }}>
                            {staff.arrival_status}
                          </div>
                        )}
                      </td>

                      <td style={{ padding: "16px 24px" }}>
                        {staff.check_out_time ? (
                          <>
                            <div style={{ color: "#0f172a", fontWeight: "700", fontSize: "15px" }}>{staff.check_out_time.substring(0, 5)}</div>
                            {staff.departure_status && staff.departure_status !== "N/A" && (
                              <div style={{ 
                                marginTop: "4px", fontSize: "11px", fontWeight: "700", display: "inline-block", padding: "2px 6px", borderRadius: "4px",
                                backgroundColor: staff.departure_status.includes("Early") ? "#fee2e2" : staff.departure_status.includes("Overtime") ? "#f3e8ff" : "#d1fae5",
                                color: staff.departure_status.includes("Early") ? "#dc2626" : staff.departure_status.includes("Overtime") ? "#9333ea" : "#059669"
                              }}>
                                {staff.departure_status}
                              </div>
                            )}
                          </>
                        ) : staff.status === "Present" ? (
                          <span style={{ display: "inline-block", padding: "4px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: "700", backgroundColor: "#fef3c7", color: "#d97706" }}>ACTIVE / INSIDE</span>
                        ) : (
                          <span style={{ color: "#94a3b8", fontWeight: "600" }}>—</span>
                        )}
                      </td>

                      <td style={{ padding: "16px 24px", textAlign: "center", color: "#475569", fontWeight: "600" }}>{staff.session_count > 0 ? staff.session_count : "—"}</td>
                      <td style={{ padding: "16px 24px", textAlign: "center", color: "#1e40af", fontWeight: "700", fontSize: "15px" }}>{staff.total_working_hours > 0 ? `${staff.total_working_hours.toFixed(2)}h` : "—"}</td>
                      
                      <td style={{ padding: "16px 24px", textAlign: "center" }}>
                        <span style={{ display: "inline-block", padding: "6px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: "700", backgroundColor: staff.status === "Present" ? "#d1fae5" : "#ffe4e6", color: staff.status === "Present" ? "#047857" : "#be123c" }}>
                          {staff.status === "Present" ? "Present" : "Absent"}
                        </span>
                      </td>
                      
                      <td style={{ padding: "16px 24px", textAlign: "center" }}>
                        <button onClick={() => setExpandedDetectionLog(expandedDetectionLog === (staff.id || staff.staff_id) ? null : (staff.id || staff.staff_id))} style={{ padding: "6px 14px", backgroundColor: "white", color: "#1e40af", border: "1px solid #1e40af", borderRadius: "6px", cursor: "pointer", fontSize: "12px", fontWeight: "700", transition: "all 0.2s" }} onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#1e40af"; e.currentTarget.style.color = "white"; }} onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "white"; e.currentTarget.style.color = "#1e40af"; }}>
                          {expandedDetectionLog === (staff.id || staff.staff_id) ? "Close" : "View"}
                        </button>
                      </td>
                    </tr>
                    {expandedDetectionLog === (staff.id || staff.staff_id) && (
                      <tr style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                        <td colSpan="12" style={{ padding: "24px" }}>
                          <div>
                            <div style={{ display: "flex", gap: "24px" }}>
                                <div style={{ textAlign: "center", backgroundColor: "white", padding: "16px", borderRadius: "8px", border: "1px solid #e2e8f0", flex: "1" }}>
                                  <div style={{ marginBottom: "12px", fontWeight: "700", color: "#475569", fontSize: "12px", textTransform: "uppercase" }}>Registered Identity</div>
                                  {staff.original_face ? (
                                    <AsyncImage 
                                      src={`${REACT_APP_API_URL}${staff.original_face}`} 
                                      alt="Original Face" 
                                      style={{ width: "100%", maxWidth: "120px", height: "120px", borderRadius: "8px", objectFit: "cover", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }} 
                                      onClick={() => setEnlargedImage(`${REACT_APP_API_URL}${staff.original_face}`)}
                                    />
                                  ) : (
                                    <div style={{ width: "100%", maxWidth: "120px", height: "120px", borderRadius: "8px", backgroundColor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: "11px", margin: "0 auto" }}>No image</div>
                                  )}
                                </div>
                                <div style={{ textAlign: "center", backgroundColor: "white", padding: "16px", borderRadius: "8px", border: "1px solid #e2e8f0", flex: "1" }}>
                                  <div style={{ marginBottom: "12px", fontWeight: "700", color: "#1e40af", fontSize: "12px", textTransform: "uppercase" }}>Latest Detection</div>
                                  {staff.detected_face ? (
                                    <AsyncImage 
                                      src={`${REACT_APP_API_URL}${staff.detected_face}`} 
                                      alt="Detected Face" 
                                      style={{ width: "100%", maxWidth: "120px", height: "120px", borderRadius: "8px", objectFit: "cover", border: "2px solid #1e40af", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }} 
                                      onClick={() => setEnlargedImage(`${REACT_APP_API_URL}${staff.detected_face}`)}
                                    />
                                  ) : (
                                    <div style={{ width: "100%", maxWidth: "120px", height: "120px", borderRadius: "8px", backgroundColor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: "11px", margin: "0 auto" }}>No image</div>
                                  )}
                                </div>
                            </div>
                            <WorkingSessionsDisplay staff={staff} onImageClick={setEnlargedImage} />
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeView === "range" && !rangeLoading && rangeReport.length > 0 && (
         <div style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", overflow: "hidden", marginBottom: "20px", border: "1px solid #e2e8f0" }}>
            <div style={{ padding: "20px 24px", borderBottom: "1px solid #e2e8f0", backgroundColor: "#f8fafc" }}>
               <h2 style={{ margin: "0", fontSize: "16px", fontWeight: "700", color: "#0f172a" }}>Period Analytics Report</h2>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f1f5f9", borderBottom: "2px solid #e2e8f0" }}>
                  <th style={{ padding: "16px 24px", textAlign: "left", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase" }}>Employee</th>
                  <th style={{ padding: "16px 24px", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase" }}>Days Present</th>
                  <th style={{ padding: "16px 24px", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase" }}>Days Absent</th>
                  <th style={{ padding: "16px 24px", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase" }}>Reliability %</th>
                  <th style={{ padding: "16px 24px", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#475569", textTransform: "uppercase" }}>Avg Hrs/Day</th>
                </tr>
              </thead>
              <tbody>
                 {rangeReport.map((staff) => (
                    <tr key={staff.staff_id} style={{ borderBottom: "1px solid #e2e8f0", backgroundColor: "#ffffff" }}>
                       <td style={{ padding: "16px 24px" }}>
                          <div style={{ fontWeight: "700", color: "#0f172a" }}>{staff.staff_name}</div>
                          <div style={{ fontSize: "12px", color: "#64748b" }}>ID: {staff.staff_id}</div>
                       </td>
                       <td style={{ padding: "16px 24px", textAlign: "center", fontWeight: "700", color: "#10b981" }}>{staff.present_days}</td>
                       <td style={{ padding: "16px 24px", textAlign: "center", fontWeight: "700", color: "#ef4444" }}>{staff.absent_days}</td>
                       <td style={{ padding: "16px 24px", textAlign: "center" }}>
                          <span style={{ display: "inline-block", padding: "4px 10px", borderRadius: "4px", backgroundColor: staff.attendance_percentage >= 80 ? "#d1fae5" : staff.attendance_percentage >= 50 ? "#fef3c7" : "#ffe4e6", color: staff.attendance_percentage >= 80 ? "#047857" : staff.attendance_percentage >= 50 ? "#b45309" : "#be123c", fontWeight: "700", fontSize: "12px" }}>
                             {staff.attendance_percentage}%
                          </span>
                       </td>
                       <td style={{ padding: "16px 24px", textAlign: "center", fontWeight: "700", color: "#1e40af" }}>{staff.avg_working_hours}h</td>
                    </tr>
                 ))}
              </tbody>
            </table>
         </div>
      )}

      {(loading || rangeLoading) && <div style={{ textAlign: "center", padding: "40px", color: "#64748b", fontWeight: "600" }}>⏳ Fetching records...</div>}
      
      {activeView === "daily" && !loading && staffMembers.length === 0 && (
        <div style={{ backgroundColor: "white", padding: "40px", borderRadius: "10px", textAlign: "center", color: "#94a3b8", fontWeight: "500", border: "1px dashed #cbd5e1" }}>
          No records found for {selectedDate}.
        </div>
      )}

      {/* FULL-SCREEN IMAGE MODAL */}
      {enlargedImage && (
        <div 
          onClick={() => setEnlargedImage(null)} 
          style={{ 
            position: "fixed", top: 0, left: 0, width: "100%", height: "100%", 
            background: "rgba(15, 23, 42, 0.9)", backdropFilter: "blur(4px)",
            display: "flex", alignItems: "center", justifyContent: "center", 
            zIndex: 99999, cursor: "pointer" 
          }}
        >
          <img 
            src={enlargedImage} 
            alt="Enlarged Detail" 
            style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "12px", objectFit: "contain", boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)", border: "4px solid white" }} 
            onClick={(e) => e.stopPropagation()} // Prevent clicking the image from closing it immediately
          />
          <button 
            onClick={() => setEnlargedImage(null)} 
            style={{ position: "absolute", top: "24px", right: "24px", background: "white", border: "none", borderRadius: "50%", width: "40px", height: "40px", fontSize: "20px", fontWeight: "bold", color: "#0f172a", cursor: "pointer", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)" }}
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
}
